import React, { lazy } from 'react';
import dashboard from '@modules/dashboard';
import setting from '@modules/setting';
import businessAffairs from '@modules/businessAffairs';
import recruitmentManage from '@modules/recruitmentManage';
import recruitManagement from '@modules/recruitManagement';
import placeManagement from '@modules/placeManagement';
import financialManage from '@modules/financialManage';
import dormitoryManage from '@modules/dormitoryManage';
import contractMannage from '@modules/contractMannage';
import contractManageV5 from '@modules/contractManageV5';
import warnManage from '@/modules/warnManage';
import salaryManage from '@/modules/salaryManage';
import attendanceManage from '@/modules/attendanceManage';
import ycFinance from '@/modules/ycFinance';
import featureRequirement from '@/modules/featureRequirement';
import internalContract from '@/modules/internalContract';

const NotAuthorized = lazy(() => import('@modules/error/notAuthorized'));

export default [
  dashboard,
  setting,
  businessAffairs,
  recruitManagement,
  recruitmentManage,
  placeManagement,
  financialManage,
  dormitoryManage,
  contractMannage,
  contractManageV5,
  warnManage,
  attendanceManage,
  salaryManage,
  ycFinance,
  featureRequirement,
  internalContract,
  {
    path: 'not-authorized',
    element: <NotAuthorized />,
  },
];
